import { Gift, Check } from "lucide-react";
import { Panel } from "@/components/PageHeader";
import { cedi } from "@/lib/api";

const Option = ({ active, onClick, children, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`text-left rounded-md border px-4 py-3 text-sm transition-colors ${active ? "border-[#E60000] bg-[#FFF0F0]" : "border-[#E5E7EB] hover:border-gray-400"}`}>
    <div className="flex items-start gap-3">
      <span className={`mt-0.5 w-4 h-4 shrink-0 rounded-full border grid place-items-center ${active ? "bg-[#E60000] border-[#E60000]" : "border-gray-400"}`}>{active && <Check className="w-3 h-3 text-white" />}</span>
      <div className="flex-1">{children}</div>
    </div>
  </button>
);

export const hasExtras = (ev) => !!(ev?.souvenir_dinner?.enabled && ev.souvenir_dinner.options?.length);

export const ExtrasStep = ({ ev, step, value, onChange }) => {
  if (!hasExtras(ev)) return null;
  const sd = ev.souvenir_dinner;
  return (
    <Panel title={`${step}. Souvenir & Dinner`} testId="reg-step-extras" right={<Gift className="w-4 h-4 text-[#E60000]" />}>
      {sd.description && <p className="text-sm text-gray-600 mb-3">{sd.description}</p>}
      <div className="grid sm:grid-cols-2 gap-2">
        <Option active={!value} onClick={() => onChange("")} testId="reg-sd-not-attending">
          <div className="font-semibold">Not attending</div><div className="text-xs text-gray-500">No charge</div>
        </Option>
        {sd.options.map((o) => (
          <Option key={o.id} active={value === o.id} onClick={() => onChange(o.id)} testId={`reg-sd-option-${o.id}`}>
            <div className="flex justify-between gap-2"><span className="font-semibold">{o.name}</span><span className="font-mono text-xs whitespace-nowrap">{cedi(o.fee)}</span></div>
            {o.description && <div className="text-xs text-gray-500 mt-0.5">{o.description}</div>}
          </Option>
        ))}
      </div>
    </Panel>
  );
};
